<template>
  <div id="contenedor-opciones-tool-bar">
    <v-tabs>
      <template
        v-for="(opcion, index) in opciones">
        <v-tab
          :key="index"
          :to="{ name: opcion.ruta }"
          exact>
          {{ opcion.nombre }}
        </v-tab>
      </template>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'EjecucionOpcinesToolBar',
  data() {
    return {
      opciones: [
        /*
        {
          nombre: 'Firmas',
          ruta: 'ejecuccionConfiguracionFirmas',
          icono: '',
        }, */
        {
          nombre: 'Plantillas',
          ruta: 'ejecucionConfiguracionPlantillas',
          icono: '',
        },
        {
          nombre: 'Etiquetas',
          ruta: 'ejecucionConfiguracionEtiquetas',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
